import { COLORS, TYPOGRAPHY, LEVELS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';
import { CONTENT_EDITION_BAR_HEIGHT } from 'Components/structural/SContentEditionBar/SContentEditionBar.style';

export default createStyleSheet({
  panelContainer: {
    position: 'sticky',
    width: 435,
    minWidth: 435,
    background: COLORS.BLUE_GRAY_LIGHT.DEFAULT,
    justifyContent: 'center',
    padding: '40px',
    height: `calc(100vh - ${CONTENT_EDITION_BAR_HEIGHT}px)`,
    overflowY: 'auto',
    zIndex: LEVELS.PANEL,
    top: CONTENT_EDITION_BAR_HEIGHT,
  },
  title: {
    ...TYPOGRAPHY.HERO_L_BOLD,
    marginBottom: '32px',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 0,
  },
  inputBackground: {
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  firstFormContainer: {
    display: 'flex',
    marginTop: '32px',
    gap: '32px',
  },
  knowMoreTextArea: {
    paddingTop: 16,
  },
  idSection: {
    display: 'flex',
    flexDirection: 'column',
    flex: 'auto',
  },
  idField: {
    marginBottom: '24px',
  },
  thematicSection: {
    marginBottom: '24px',
  },
  thematicLabel: {
    marginBottom: '8px',
  },
  thematicSelector: {
    marginBottom: '24px',
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  thematicButton: {
    marginLeft: '8px',
  },
});
